import React from 'react';
import './RoomsGrid.css';

const RoomsGrid = () => {
  return (
    <section className="rooms-grid-section">
      <div className="rooms-grid-container">
        {/* Section Header */}
        <div className="rooms-section-header">
          <h2 className="rooms-section-title">Our Rooms & Accommodation</h2>
          <p className="rooms-section-description">
            Choose from our thoughtfully designed rooms that blend comfort with elegance. Each room is equipped with modern amenities while maintaining the charm of traditional Rajasthani hospitality.
          </p>
        </div>

        <div className="rooms-comparison-grid">
          {/* Standard Room */}
          <div className="room-type-card">
            <div className="room-type-header">
              <h2>Standard Room</h2>
              <div className="room-type-price">₹999<small>/night</small></div>
              <div className="room-type-availability">3 Rooms Available</div>
            </div>
            <div className="room-type-features">
              <h3>Room Features</h3>
              <ul className="features-list">
                <li>Comfortable bedding</li>
                <li>Air conditioning</li>
                <li>Attached bathroom with hot water</li>
                <li>TV with cable channels</li>
                <li>Free WiFi</li>
                <li>Daily housekeeping</li>
                <li>Wardrobe and storage space</li>
                <li>Window with natural lighting</li>
              </ul>
            </div>
          </div>

          {/* Deluxe Room */}
          <div className="room-type-card">
            <div className="room-type-header">
              <h2>Deluxe Room</h2>
              <div className="room-type-price">₹1,999<small>/night</small></div>
              <div className="room-type-availability">10 Rooms Available</div>
            </div>
            <div className="room-type-features">
              <h3>Room Features</h3>
              <ul className="features-list">
                <li>Spacious room with extra space</li>
                <li>Premium bedding and mattress</li>
                <li>Air conditioning</li>
                <li>Modern attached bathroom</li>
                <li>LED TV with cable channels</li>
                <li>High-speed WiFi</li>
                <li>Seating area</li>
                <li>Work desk and chair</li>
                <li>Daily housekeeping</li>
                <li>Ample wardrobe space</li>
                <li>Heritage-inspired decor</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RoomsGrid;
